export const firebaseConfig = {
    apiKey: 'AIzaSyDwLEHd1JLMMuJ9fKNP4FLb0sjhSuZiIHA',
    authDomain: 'scope-360.firebaseapp.com',
    projectId: 'scope-360',
    storageBucket: 'scope-360.firebasestorage.app',
    messagingSenderId: '952738485980',
    appId: '1:952738485980:web:2f37b1d3fefd696dddc619'
};
